import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import useFetch from '../../server/useFetch';
import Theme from '../../styles/Theme/Theme';
import Spinner from '../Global/Atomics/Spinner';
import { Text } from '../Global/Atomics/Text';
import { WidgetCard } from '../Global/Atomics/WidgetCard';
import CustomIcon from '../Global/Icons/CustomIcon';
import query from '../../server/constants.api';

const ForecastHour = styled.div`
    display: ${props => (props.display ? props.display : 'flex')}; 
    flex-direction: column; 
    align-Items: flex-end;
    margin-left: ${Theme.spacing.xs};
    @media ${Theme.devices.videowall} {
        margin-left: ${Theme.spacing.videowall.sm}
    }
    /* Also apply when useVideowallMode() is active (standard monitor used as videowall output),
       or when inside the VideoWallGrid editor preview (WidgetScaleWrap has the attribute). */
    :root[data-display-mode="videowall"] &,
    [data-display-mode="videowall"] & {
        margin-left: ${Theme.spacing.videowall.sm}
    }
`;

export const WeatherWidget = ({ canvas = false }) => {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const newDate = new Date().getHours() + ':' + String(new Date().getMinutes()).padStart(2, "0");
    const month = months[new Date().getMonth()];

    const [actualDate, setActualDate] = useState(newDate);
    const [actualMonth, setActualMonth] = useState(month);

    let currentTimestamp = Math.floor(new Date().getTime() / 1000) - 3600;

    const {
        data: currentWeather,
        refetch: refetchCurrentWeather
    } = useFetch("/weather/current", "currentWeather", {
        location: 'Cascais',
        timestamp: currentTimestamp
    }, 300000, query.middlewareURL);

    const {
        data: forecastWeather,
        refetch: refetchForecastWeather
    } = useFetch("/weather/forecast", "forecastWeather", {
        location: 'Cascais',
        timestamp: currentTimestamp
    }, 300000, query.middlewareURL);

    useEffect(() => {
        setInterval(() => {
            const newDate = new Date().getHours() + ':' + String(new Date().getMinutes()).padStart(2, "0");
            const month = months[new Date().getMonth()];
            setActualDate(newDate);
            setActualMonth(month);
        }, 30000);
    }, []);

    return (
        <WidgetCard backgroundColor={Theme.color['blue-7']} display='flex' flexDirection='column' padding={Theme.spacing.videowall.md} margin={Theme.spacing.videowall.xxs} style={{ color: 'white', overflow: 'hidden' }}>
            {currentWeather !== null ?
                <>
                    <div style={{ display: 'flex', flex: '1 1 60%', justifyContent: 'space-between', marginBottom: Theme.spacing.videowall.xs, overflow: 'hidden', minHeight: 0 }}>
                        {/* Margin bottom not variable */}
                        <div style={{ display: 'flex', placeItems: 'center', alignSelf: 'baseline', overflow: 'hidden', minWidth: 0 }}>
                            <Text fontSize={canvas ? 'text_xl' : 'text_xxxl'} marginRight={Theme.spacing.videowall.sm} fontWeight={Theme.typography.weight.light} style={{ whiteSpace: 'nowrap' }}>{actualDate}</Text>
                            <CustomIcon icon={currentWeather?.[0]?.Weather} iconSize='xs' color={Theme.color['teal-3']} />
                            <Text fontSize={canvas ? 'text_md' : 'text_xl'} marginLeft={Theme.spacing.videowall.xxs} fontWeight={Theme.typography.weight.light} style={{ whiteSpace: 'nowrap' }}>{currentWeather?.[0]?.Temperature ? Number(currentWeather?.[0]?.Temperature).toFixed(0) + 'º' : ''}</Text>
                        </div>
                        {forecastWeather !== null ?
                            <div style={{ display: 'flex', gap: '10px', flexShrink: 0 }}>
                                {forecastWeather?.[0] !== null ?
                                    <ForecastHour display={forecastWeather?.[0] !== null ? null : 'none'}>
                                        <Text fontSize={canvas ? 'text_md' : 'text_xl'} fontWeight={Theme.typography.weight.light} marginBottom={Theme.spacing.videowall.xxxs} >+1h</Text>
                                        <div style={{ display: 'flex', alignItems: 'center' }}><CustomIcon icon={forecastWeather?.[0].Weather} iconSize='xs' color={Theme.color['teal-3']} /><Text fontSize={canvas ? 'text_md' : 'text_xl'} marginLeft={Theme.spacing.videowall.xxs}>{Number(forecastWeather?.[0].Temperature).toFixed(0)}</Text></div>
                                    </ForecastHour>
                                    : null}
                                {forecastWeather?.[1] !== null ?
                                    <ForecastHour display={forecastWeather?.[1] !== null ? null : 'none'}>
                                        <Text fontSize={canvas ? 'text_md' : 'text_xl'} fontWeight={Theme.typography.weight.light} marginBottom={Theme.spacing.videowall.xxxs}>+2h</Text>
                                        <div style={{ display: 'flex', alignItems: 'center' }}><CustomIcon icon={forecastWeather?.[1].Weather} iconSize='xs' color={Theme.color['teal-3']} /><Text fontSize={canvas ? 'text_md' : 'text_xl'} marginLeft={Theme.spacing.videowall.xxs}>{Number(forecastWeather?.[1].Temperature).toFixed(0)}</Text></div>
                                    </ForecastHour>
                                    : null}
                            </div>
                            : null}
                    </div>
                    <div style={{ display: 'flex', flex: '0 0 auto', justifyContent: 'space-between', alignItems: 'flex-end', overflow: 'hidden' }}>
                        <Text fontSize={canvas ? 'text_md' : 'text_xl'} color={Theme.color['blue-1']} margin='0' fontWeight={Theme.typography.weight.medium} style={{ whiteSpace: 'nowrap' }}>Cascais</Text>
                        <Text fontSize={canvas ? 'text_sm' : 'text_lg'} color={Theme.color['white']} margin='0' fontWeight={Theme.typography.weight.light} style={{ whiteSpace: 'nowrap' }}>{actualMonth}</Text>
                    </div>
                </>
                : <div style={{ height: 'inherit', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}><Spinner stroke="green" size='20px' /></div>}
        </WidgetCard>
    );
};